/** Blog posts carry free-text `blog_tag` arrays from the CMS. */
export const tagsOf = (item) =>
  Array.isArray(item?.blog_tag)
    ? item.blog_tag.map((tag) => String(tag).trim()).filter(Boolean)
    : [];

export const ALL_TOPICS = "All";
